/* eslint-disable no-unused-vars */
import api from '@/api/api'
import router from '@/router/index'
import { normalize, schema } from 'normalizr'
import modulos, { modulo } from './modulos/store'

export const modulosOrden = new schema.Entity('modulosOrden', {'modulos': [modulo]})

export default {
  namespaced: true,
  modules: {
    modulos
  },
  state: {
    list: {}
  },
  mutations: {
    setAll (state, payload) {
      state.list = Object.assign({}, payload)
    }
  },
  actions: {
    load ({ commit, dispatch }, id) { // Devuelve todos los modulos
      return new Promise((resolve, reject) => {
        api.get('/modulosOrdenes/get', {
          params: {
            jsondata: JSON.stringify({
              parametros: {
                id
              }
            })
          }
        })
          .then(response => {
            if (response.data.result.ok) {
              let normalizedData = normalize(response.data.result.data.data, modulosOrden)
              commit('modulosOrdenes/modulos/setAll', normalizedData.entities.modulo, {root: true})
              commit('setAll', normalizedData.entities.modulosOrden)
              resolve()
            } else {
              switch (response.data.result.code) {
                case 1:
                  dispatch('alerts/addNotLoggedIn', null, { root: true })
                  router.push({ name: 'login' })
                  break
              }
              reject(response.data.result)
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    loadActual ({ commit, dispatch }, obj) { // Devuelve todos los modulos
      return new Promise((resolve, reject) => {
        api.get('/modulosOrdenes/get_actual', {
          params: {
            jsondata: JSON.stringify({
              parametros: {
                alquiler: obj.alquiler,
                codigoPromocion: obj.codigoPromocion,
                simplificada: obj.simplificada

              }
            })
          }
        })
          .then(response => {
            if (response.data.result.ok) {
              let normalizedData = normalize(response.data.result.data.data, modulosOrden)
              commit('setAll', normalizedData.entities.modulosOrden)
              commit('modulosOrdenes/modulos/setAll', normalizedData.entities.modulo, {root: true})
              resolve()
            } else {
              switch (response.data.result.code) {
                case 1:
                  dispatch('alerts/addNotLoggedIn', null, { root: true })
                  router.push({ name: 'login' })
                  break
              }
              reject(response.data.result)
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    loadActuales ({ commit, dispatch }, codigoPromocion) { // Devuelve todos los modulos
      return new Promise((resolve, reject) => {
        api.get('/modulosOrdenes/get_actuales', {
          params: {
            jsondata: JSON.stringify({
              parametros: {
                codigoPromocion
              }
            })
          }
        }).then(response => {
            if (response.data.result.ok) {
              let normalizedData = normalize(response.data.result.data.data, [modulosOrden])
              commit('setAll', normalizedData.entities.modulosOrden)
              commit('modulosOrdenes/modulos/setAll', normalizedData.entities.modulo, {root: true})
              resolve()
            } else {
              switch (response.data.result.code) {
                case 1:
                  dispatch('alerts/addNotLoggedIn', null, { root: true })
                  router.push({ name: 'login' })
                  break
              }
              reject(response.data.result)
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    crear ({ commit, dispatch }, obj) { // Devuelve todos los modulos
      return new Promise((resolve, reject) => {
        api.post('/modulosOrdenes/crear', {
          jsondata: JSON.stringify({
            parametros: {
              modulosOrden: obj
            }
          })
        })
          .then(response => {
            if (response.data.result.ok) {
              let normalizedData = normalize(response.data.result.data.data, [modulosOrden])
              commit('setAll', normalizedData.entities.modulosOrden)
              commit('modulosOrdenes/modulos/setAll', normalizedData.entities.modulo, {root: true})
              resolve()
            } else {
              switch (response.data.result.code) {
                case 1:
                  dispatch('alerts/addNotLoggedIn', null, { root: true })
                  router.push({ name: 'login' })
                  break
              }
              reject(response.data.result)
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    borrar ({ commit, dispatch }, obj) { // Devuelve todos los modulos
      return new Promise((resolve, reject) => {
        api.post('/modulosOrdenes/borrar', {
          jsondata: JSON.stringify({
            parametros: obj
          })
        })
          .then(response => {
            if (response.data.result.ok) {
              resolve()
            } else {
              switch (response.data.result.code) {
                case 1:
                  dispatch('alerts/addNotLoggedIn', null, { root: true })
                  router.push({ name: 'login' })
                  break
              }
              reject(response.data.result)
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    }

  },
  getters: {
    getAll (state) {
      return Object.keys(state.list).map(id => state.list[id])
    },
    getActual (state, getters) {
      return getters.getAll.length > 0 ? getters.getAll[0] : null
    },
    getByAlquiler (state, getters) {
      return obj => getters.getAll.find(x => obj.alquiler === x.alquiler && obj.simplificada === x.simplificada && obj.codigoPromocion === x.codigoPromocion)
    },
    getGenerarContratoKyc (state, getters) {
      return getters.getAll.length > 0 ? getters.getAll[0].generarContratoKyc : null
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modulosOrdenes/store.js